import { render } from "./AppGoUpButton.vue?vue&type=template&id=3eec13fb&scoped=true"
import script from "./AppGoUpButton.vue?vue&type=script&lang=js"
export * from "./AppGoUpButton.vue?vue&type=script&lang=js"

import "./AppGoUpButton.vue?vue&type=style&index=0&id=3eec13fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eec13fb"]])

export default __exports__